import { httpClient } from '../../services/http-client'
import { AppSetting } from '../../models/app-setting'

class AppSettingApi {
    getAll() {
        return httpClient
            .get('/appSettings/getall').then(res => {
                return res.data
            })
    }

    get(key: string) {
        return httpClient
            .get(`/appSettings/get?key=${key}`).then(res => {
                return res.data.value
            })
    }

    update(setting: AppSetting) {
        return httpClient.post('/appSettings/update', setting)
    }
}

export const appSettingsApi = new AppSettingApi()
